module.exports = __webpack_public_path__ + "static/media/plant.ece9a5fa.svg";